import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_novelty_vehicle_maintenance,
    CREATE_NOVELTY_VEHICLE_MAINTENANCE,
    createNoveltyVehicleMaintenance,
    getAllNoveltyVehicleMaintenance,
    // get_report,
    // GET_REPORT,
    getItemNoveltyVehicleMaintenance, 
    updateNoveltyVehicleMaintenance, 
    UPDATE_NOVELTY_VEHICLE_MAINTENANCE,
} from '../../../redux/novelty_maintenance_vehicle';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import Card from "../../../components/card";
import {get_status, URLAPI} from "../../../config"
import Modal from "../../../components/modal";
import {getAllVehicle} from "../../../redux/vehicles";


const NoveltyVehicleMaintenanceAdmin = (props) => {
    const dispatch = useDispatch();

    const _get_all_novelty_vehicle_maintenance = useSelector((state) => state.novelty_vehicle_maintenance_module._get_all_novelty_vehicle_maintenance);

    const _get_all_vehicle = useSelector((state) => state.vehicle_module._get_all_vehicle);

    const _create_novelty_vehicle_maintenance = useSelector((state) => state.novelty_vehicle_maintenance_module._create_novelty_vehicle_maintenance);
    const _update_novelty_vehicle_maintenance = useSelector((state) => state.novelty_vehicle_maintenance_module._update_novelty_vehicle_maintenance);

    // const _get_report = useSelector((store) => store.novelty_vehicle_maintenance_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllNoveltyVehicleMaintenance(token));
        // eslint-disable-next-line
    }, [token, dispatch]);

    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [vehicle_select, setVehicleSelect] = useState([]);
    const [vehicle_select_filter, setVehicleSelectFilter] = useState([]);
    const [invoice, setInvoice] = useState('');
    const [value, setValue] = useState(0);
    const [modalDecline, setModalDecline] = useState(false);
    const [observation, setObservation] = useState('');

    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (_get_all_vehicle && _get_all_vehicle.data && _get_all_vehicle.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_vehicle.data.datos.map(element => {
                if (element.activo === true) {
                    array.push({
                        value: element.id,
                        label: element.placa
                    })
                }
            })
            setVehicles(array);
        }
    }, [_get_all_vehicle]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Vehículo', id: 2},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_vehicle: false,
        id_vehicle: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_vehiculo: 0,
        vehiculo: '',
        descripcion: "",
        foto: "",
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_novelty_vehicle_maintenance.status === 201) {
            toast.success("Novedad de mantenimiento creada correctamente");
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_novelty_vehicle_maintenance(CREATE_NOVELTY_VEHICLE_MAINTENANCE));
            dispatch(getAllNoveltyVehicleMaintenance(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_novelty_vehicle_maintenance.status !== 0) {
            toast.error(_create_novelty_vehicle_maintenance.message);
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_novelty_vehicle_maintenance(CREATE_NOVELTY_VEHICLE_MAINTENANCE));
            setIsLoading(false);
        }
    }, [_create_novelty_vehicle_maintenance, dispatch, initForm, token]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_novelty_vehicle_maintenance && _get_all_novelty_vehicle_maintenance.data && _get_all_novelty_vehicle_maintenance.data.datos) {
            setDatas(_get_all_novelty_vehicle_maintenance.data.datos);
        }

    }, [_get_all_novelty_vehicle_maintenance, count, props]);

    const loadFunc = () => {
        if (_get_all_novelty_vehicle_maintenance.data.datos) {
            if (_get_all_novelty_vehicle_maintenance.data.datos.length > count) {
                const ordenado = _get_all_novelty_vehicle_maintenance.data.datos.sort((a, b) => {
                    return new Date(b.fecha_creacion + ' 00:00:00') - new Date(a.fecha_creacion + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setVehicleSelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_novelty_vehicle_maintenance.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_vehicle: false,
                id_vehicle: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2') {
            setOtherFilter({
                visible_vehicle: true,
                id_vehicle: 0,
            });
        } else {
            setOtherFilter({
                visible_vehicle: false,
                id_vehicle: 0,
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "id_vehiculo") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleFileChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.files[0],
        });
    };

    const handleChangeVehicle = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_vehiculo']: parseInt(e.value),
            // eslint-disable-next-line
            ['vehiculo']: parseInt(e.label),
        });
        setVehicleSelect(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (form.id_vehiculo === 0) {
            toast.error("Debe seleccionar el vehículo");
            setIsLoading(false);
            return;
        }
        if (form.descripcion === "") {
            toast.error("Debe ingresar la descripción del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (form.foto === "") {
            toast.error("Debe seleccionar una foto");
            setIsLoading(false);
            return;
        }
        dispatch(createNoveltyVehicleMaintenance(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_novelty_vehicle_maintenance.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_novelty_vehicle_maintenance.data.datos.filter(element => {
            if (element.vehiculo.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_novelty_vehicle_maintenance.data.datos.filter(x => {
                    if (x.fecha_novedad) {
                        let fecha = new Date(x.fecha_novedad);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    // useEffect(() => {
    //     if (_get_report.status === 200) {
    //         toast.success(_get_report.data.mensaje);
    //         dispatch(clear_novelty_vehicle_maintenance(GET_REPORT));
    //         setIsLoading(false);
    //     } else if (_get_report.status !== 0) {
    //         toast.error(_get_report.message);
    //         dispatch(clear_novelty_vehicle_maintenance(GET_REPORT));
    //         setIsLoading(false);
    //     }
    // }, [_get_report, dispatch])
    //
    // const handleGenerateReport = (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
    //     dispatch(get_report({
    //         'fecha_inicio': range_date.date_start,
    //         'fecha_fin': range_date.date_end,
    //         'id_establecimiento': other_filter.id_establishment,
    //         'id_operario': other_filter.id_operator,
    //         'id_tipo_novedad': other_filter.id_type_novelty_vehicle_maintenance,
    //     }, token));
    //
    // }

    const handleChangeVehicleFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_vehicluo': parseInt(e.value),
        });
        let va = _get_all_novelty_vehicle_maintenance.data.datos.filter(x => parseInt(x.id_vehiculo) === parseInt(e.value));
        setDatas(va);
        setVehicleSelectFilter(e);
    }

    const initSelect = {
        id: 0,
        secuencial: "",
        vehiculo: "",
        empleado: "",
        descripcion: "",
        fecha_creacion: "",
        foto: "",
        factura: "",
        observacion: "",
        estado: "",
        valor: "",
    };

    const [DataSelected, setDataSelected] = useState(initSelect);
    const [modalConfirm, setModalConfirm] = useState(false);

    const onItemClickListener = async (item) => {
        const response = await getItemNoveltyVehicleMaintenance(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_novelty_vehicle_maintenance.status === 200) {
            toast.success(_update_novelty_vehicle_maintenance.data.mensaje);
            dispatch(clear_novelty_vehicle_maintenance(UPDATE_NOVELTY_VEHICLE_MAINTENANCE));
            dispatch(getAllNoveltyVehicleMaintenance(token));
            setIsLoading(false);
            setModalConfirm(false);
            setModalDecline(false);
            setShowDetail(false);
        } else if (_update_novelty_vehicle_maintenance.status !== 0) {
            toast.error(_update_novelty_vehicle_maintenance.message);
            dispatch(clear_novelty_vehicle_maintenance(UPDATE_NOVELTY_VEHICLE_MAINTENANCE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_novelty_vehicle_maintenance, dispatch])

    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!value) {
            toast.error("Debe ingresar el costo del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (!invoice) {
            toast.error("Debe seleccionar una factura");
            setIsLoading(false);
            return;
        }
        dispatch(updateNoveltyVehicleMaintenance(token, DataSelected.id, {'valor': value, 'factura': invoice, 'observacion': observation, 'estado': 'CONFIRMADO'}))
    }

    const handleDeclineSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (observation === '') {
            toast.error("Debe ingresar un motivo");
            setIsLoading(false);
            return;
        }
        dispatch(updateNoveltyVehicleMaintenance(token, DataSelected.id, {"estado": "RECHAZADO", "observacion": observation}))
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Novedades de mantenimientos"
                            items={[{label: "Listado de novedades de mantenimientos", link: "/novedades-mantenimientos"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">

                    <div className="content-area-wrapper" style={{margin: 0}}>


                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_noveltyvehiclemaintenance").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        dispatch(getAllVehicle(token));
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm);
                                                        setShowOverlay(!showSibarRight);
                                                        setVehicleSelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-novelty_vehicle_maintenance"
                                                    name="filtro-novelty_vehicle_maintenance"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_vehicle && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Vehículo</label>
                                                                <Select
                                                                    options={vehicles}
                                                                    isMulti={false}
                                                                    onChange={handleChangeVehicleFilter}
                                                                    value={vehicle_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {

                                    permisos.filter(element => element.codigo === "add_noveltyvehiclemaintenance").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="novelty_vehicle_maintenancea">
                                                        Nueva novedad de mantenimiento
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Vehículo</label>
                                                            <Select
                                                                options={vehicles}
                                                                isMulti={false}
                                                                onChange={handleChangeVehicle}
                                                                value={vehicle_select}
                                                            />
                                                            <br/>
                                                            <TextArea
                                                                id="descripcion"
                                                                name="descripcion"
                                                                label="Descripción"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.descripcion}
                                                            />
                                                            <Input
                                                                label="Foto"
                                                                name="foto"
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={handleFileChange}
                                                            />
                                                            <br/>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR NOVELTY_VEHICLE_MAINTENANCE
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por vehículo o número de solicitud"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                {/*{ permisos && permisos.filter(x => x.codigo === 'generate_report_novelty_vehicle_maintenance').length > 0 &&*/}
                                                                {/*    <div className="col-2">*/}
                                                                {/*        <Button*/}
                                                                {/*            text={<h3><i*/}
                                                                {/*                className="text-white bx bx-export"/></h3>}*/}
                                                                {/*            theme="success"*/}
                                                                {/*            type="button"*/}
                                                                {/*            classes="btn-lg round"*/}
                                                                {/*            onClick={handleGenerateReport}*/}
                                                                {/*        />*/}
                                                                {/*    </div>*/}
                                                                {/*}*/}
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.vehiculo}
                                                                    subtitle={item.secuencial}
                                                                    rightDescription={item.estado}
                                                                    bulletType={get_status(item.estado)}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                 <div className="mail-items">
                                                                                    <small>{item.empleado}</small>
                                                                                </div>
                                                                                <div className="mail-items">
                                                                                    <span>Fecha: </span>{item.fecha_creacion}
                                                                                </div>

                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}
                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                                <div className="email-header-right mb-1 ml-2 pl-1">
                                                    <span
                                                        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>
                                                        {DataSelected.estado}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.vehiculo}
                                                                subtitle={"Fecha: " + DataSelected.fecha_creacion}
                                                            >
                                                                <div className="row">
                                                                    {(DataSelected.descripcion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Empleado: </h6>{DataSelected.empleado}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.descripcion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Descripción: </h6>{DataSelected.descripcion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.foto) &&
                                                                        <div className="col-12 mb-1">
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={`${URLAPI}${DataSelected.foto}`} target="_blank" className="btn btn-info">
                                                                                Ver foto
                                                                            </a>
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.factura) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Factura</h6>
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={`${URLAPI}${DataSelected.factura}`} target="_blank">
                                                                                <img
                                                                                    className="logo"
                                                                                    src="/base/app-assets/images/icon/pdf.png"
                                                                                    alt="logo"
                                                                                    style={{width: "100px",height: "auto", }}
                                                                                />
                                                                            </a>

                                                                        </div>
                                                                    }
                                                                    {(DataSelected.valor) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Costo del mantenimiento: </h6>{DataSelected.valor}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.observacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Observación: </h6>{DataSelected.observacion}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {
                                                                            (permisos.filter(x => x.codigo === 'change_noveltyvehiclemaintenance').length > 0 && (DataSelected.estado === 'CREADO')) &&
                                                                                <>
                                                                                    <Button
                                                                                        text="Rechazar"
                                                                                        onChange={
                                                                                            () => {
                                                                                                setObservation("");
                                                                                                setModalDecline(true);
                                                                                            }
                                                                                        }
                                                                                        theme="danger"
                                                                                        classes="button_div1"
                                                                                        type="button"
                                                                                        disabled={isLoading}
                                                                                    />
                                                                                    <Button
                                                                                        text="Confirmar"
                                                                                        onChange={
                                                                                            () => {
                                                                                                setInvoice('');
                                                                                                setObservation('');
                                                                                                setModalConfirm(true);
                                                                                            }
                                                                                        }
                                                                                        theme="success"
                                                                                        classes="button_div1"
                                                                                        type="button"
                                                                                        disabled={isLoading}
                                                                                    />
                                                                                </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modalDecline}>
                <form onSubmit={handleDeclineSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Rechazar</h5>
                        <div className="form-group">
                            <TextArea
                                id="observacion"
                                name="observacion"
                                label="Observación"
                                placeholder=""
                                onChange={(e) => setObservation(e.target.value)}
                                rows={4}
                                value={observation}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalDecline(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalConfirm}>
                <form onSubmit={handleUpdateSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Confirmar</h5>
                        <div className="form-group">
                            <Input
                                label="Costo del mantenimiento"
                                name="valor"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Factura"
                                name="archivo"
                                type="file"
                                accept=".docx,.pdf"
                                onChange={(e) => setInvoice(e.target.files[0])}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                id="observacion"
                                name="observacion"
                                label="Observación"
                                placeholder=""
                                onChange={(e) => setObservation(e.target.value)}
                                rows={4}
                                value={observation}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalConfirm(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default NoveltyVehicleMaintenanceAdmin;
